import React , {useEffect,useState} from "react";  /////
import Loader from '../../utils/Loader';
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetCourseListQuery,useShowReviewEnrollmentQuery,useUpdateReviewEnrollmentMutation,useUpdateStudentMutation,useGetManagerListQuery } from "../../Services/api";
export default function UpdateEnrollment(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required("first name fields is required"),
        last_name: Yup.string().required("last name fields is required"),
        mobile_number: Yup.string().required("phone number fields is required"),
        email: Yup.string().required("email fields is required"),
        dob: Yup.string().required("date of birth fields is required"),
        mail_address: Yup.string().required("mail address fields is required"),
        // referred_by: Yup.string().required("referred by fields is required"),
        // addition_email: Yup.string().required("addition email fields is required"),
        allocate_trainer: Yup.string().required("allocate trainer fields is required"),
    });
      const {
        data: ShowReview,
        isLoading: isGetLoading,
      } =  useShowReviewEnrollmentQuery({  params:props['id']});
      const [UpdateReviewEnrollment,isLoading] = useUpdateReviewEnrollmentMutation();
      const studentData= ShowReview?.data[0];
     
      var  defaultValues={
        first_name:studentData?.first_name,
        last_name:studentData?.last_name,
        email:studentData?.email,
        mobile_number:studentData?.mobile,
        dob:studentData?.dob,
        mail_address:studentData?.address,
        referred_by:studentData?.referred_by,
        nationality:studentData?.nationality,
        gender:studentData?.gender,
        language:studentData?.language,
        company:studentData?.company,
        job_position:studentData?.job_position,
        source:studentData?.source,
        platform:studentData?.platform,
        company:studentData?.company,
        addition_email:studentData?.addition_email ? studentData?.addition_email : studentData?.email,
        allocate_trainer:studentData?.allocate_trainer,
        gender:studentData?.gender,

    };
   
    const methods = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues, 
    });
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[studentData]) 
    const updateStudentList = (values,e) => {
        UpdateReviewEnrollment({ data: values,param:props['id'] })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: ManagerList        
    } = useGetManagerListQuery();
    const {  
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [studentId, setStudentId] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const nameToHandler = (value) => {
        setValue("student_id", value[0]?.value);
        setStudentId([...value])
    }
    const findDate=(e)=>{
        const currentDate = new Date();
        const today = currentDate.toISOString().split('T')[0]
        if(e==1){
            currentDate.setMonth(currentDate.getMonth() + 1);
        }
        else if(e==2){
            currentDate.setMonth(currentDate.getMonth() + 3);
        }
        else if(e==3){
            currentDate.setMonth(currentDate.getMonth() + 6);
        }
        else if(e==4){
            currentDate.setMonth(currentDate.getMonth() + 12);
        }
        const formattedDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        setStartDate(today);
        setEndDate(formattedDate);
        setValue("start_date",today);
        setValue("end_date",formattedDate);
    }
    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update student Enrollment</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update student Enrollment</h5>
                        <form onSubmit={handleSubmit(updateStudentList)} >
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">first name</label>
                                <input type="name" {...register("first_name")} className="form-control" />
                                <span className="text-danger">{errors.first_name?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className="col-form-label text-capitalize">last name</label>
                                <input type="name" {...register("last_name")} className="form-control" />
                                <span className="text-danger">{errors.last_name?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">mobile number</label>
                                <input type="number" {...register("mobile_number")} className="form-control" />
                                <span className="text-danger">{errors.mobile_number?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className="col-form-label text-capitalize">email</label>
                                <input type="email" {...register("email")} className="form-control" />
                                <span className="text-danger">{errors.email?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">date fo birth</label>

                                <input type="date" {...register("dob")} className="form-control" />
                                <span className="text-danger">{errors.dob?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">mail address</label>
                                <input type="name" {...register("mail_address")} className="form-control" />
                                <span className="text-danger">{errors.mail_address?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputEmail" className="col-form-label">Select referred by</label>

                                <select  {...register("referred_by")} className="form-control" >
                                 <option value="">Select referred by</option>                                           

                                {                            
                                ManagerList?.data?.map((item) => {
                                    return (
                                        <option key={item.teacher_id} value={item.teacher_id}>{item.name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.referred_by?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">addition email</label>

                                <input type="email" {...register("addition_email")} className="form-control" />
                                <span className="text-danger">{errors.addition_email?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputEmail" className=" col-form-label">Select allocate trainer</label>
                                <select  {...register("allocate_trainer")} className="form-control" >
                                {                            
                                ManagerList?.data?.map((item) => {
                                    return (
                                        <option key={item.teacher_id} value={item.teacher_id}>{item.name}</option>                                           
                                        )
                                    })
                                }
                                </select>   
                                <span className="text-danger">{errors.allocate_trainer?.message}</span>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">nationality</label>
                                <input type="text" {...register("nationality")} className="form-control" />
                                <span className="text-danger">{errors.nationality?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">language</label>
                                <input type="text" {...register("language")} className="form-control" />
                                <span className="text-danger">{errors.language?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">age</label>
                                <input type="date" {...register("dob")} className="form-control" />
                                <span className="text-danger">{errors.dob?.message}</span>
                            </div>
                            
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputEmail" className="col-form-label">Select gender</label>
                                <select  {...register("gender")} className="form-control" >
                                <option value="male">male</option> 
                                <option value="female">female</option> 
                                </select>   
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">Company</label>
                                <input type="text" {...register("company")} className="form-control" />
                                <span className="text-danger">{errors.company?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">job position</label>
                                <input type="text" {...register("job_position")} className="form-control" />
                                <span className="text-danger">{errors.job_position?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputEmail" className="col-form-label">How did you hear about QHSE International?</label>
                                <input type="text" {...register("source")} className="form-control" />
                                <span className="text-danger">{errors.source?.message}</span> 
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">payment amount</label>
                                <input type="number" {...register("payment_amount")} className="form-control" />
                                <span className="text-danger">{errors.payment_amount?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">course</label>
                                <select  {...register("activity", { required: true })} className="form-control">
                                    <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.course_id && <span  className="text-danger">Course is required</span>}
                            
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputEmail" className="col-form-label">License</label>
                                <select  {...register("license_validity", { required: true })} className="form-control"  onChange={(e)=>findDate(e.target.value)}>
                                    <option value="">Select validity</option>
                                    <option value="1">1 Month</option>
                                    <option value="2">3 Months</option>
                                    <option value="3">6 Months</option>
                                    <option value="4">1 Year</option>
                                </select>
                                <span className="text-danger">{errors.license_validity?.message}</span> 
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">start date</label>
                                <input type="date" value={startDate} className="form-control" />
                                <span className="text-danger">{errors.start_date?.message}</span>
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="inputText" className=" col-form-label text-capitalize">end date</label>
                                <input type="date"  value={endDate} className="form-control" />
                                <span className="text-danger">{errors.end_date?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-4">
                                <label htmlFor="inputEmail" className="col-form-label">Platform</label>
                                <select  {...register("platform", { required: true })} className="form-control">
                                    
                                    <option value="1">QHSE eLearning</option>
                                    {/* <option value="2">TWI</option>
                                    <option value="3">EBS</option>
                                    <option value="4">TUV</option>	 */}
                                </select>
                                <span className="text-danger">{errors.platform?.message}</span> 
                            </div>
                            
                        </div>
                        <div className="modal-footer">
                               {isLoading.status !='pending' ?  
                                    <button type="submit" className="btn btn-warning" >Approve</button>
                                    :
                                    <button type="submit" className="btn btn-warning" ><div className="spinner-border text-muted"></div></button>
                                }
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
        </div>
    );
}